__turbopack_context__.v({
  "accountMenu": "M1sJgq_accountMenu",
  "logoutMenu": "M1sJgq_logoutMenu",
  "menu": "M1sJgq_menu",
  "menuBottom": "M1sJgq_menuBottom",
  "menuBottomMen": "M1sJgq_menuBottomMen",
  "menuItem": "M1sJgq_menuItem",
  "menuMen": "M1sJgq_menuMen",
  "socialMenu": "M1sJgq_socialMenu",
});
